import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

type Props = BoxProps;

/**
 * The stacked lockup, sized by height.  The width cap is deliberately generous — height is what
 * decides the footprint, and a binding width cap would letterbox the mark instead.
 */
const TruentityLogo = ({ ...props }: Props) => {
  return (
    <Box
      component="img"
      src={require('@/shared/images/truentity_logo_stacked.svg')}
      alt="Truentity Health"
      {...props}
      sx={{ height: '3.375rem', width: 'auto', maxWidth: '100%', display: 'block', ...props.sx }}
    />
  );
};

export default TruentityLogo;
